export type Calendar = 'gregorian' | 'julian';
// make sure this file is generated otherwise the typings for this file are missing
export default undefined;
